export const config_url ={
    QuestionGroups : "/eappreg/getQuestionGrps",
    QuestionHierarchy : "/eappreg/getQuestionBasedOnHierarchy/",
    getTRCMaxLevel : "/eappreg/getMaxLevel/",
    GetStreetType : "/eappreg/getStreetType",
    GetUnitType : "/eappreg/getUnitType",
    GetMiscTypeBusiness : "/eappreg/getMiscType",
    GetQuestionGrpId : "/eappreg/getQuestionGrpsBasedonMetaName/",
    getTRCLevel : "/eappreg/getCurrLevel/",
    DisplayCurrLvlQues : "/eappreg/getCurrLvlQuesToDisplay",
    GetGrpQuestions: "/eappreg/getGrpQuestions",
    QuestionDetails : "/eappreg/getQuestionsDetail/",
    GetPermitQues : "/eappreg/getPermitQuestions/" ,
    GetSystemDate : "/eappreg/getSystemTestDate" ,
    GetNextGUN : "/eappreg/getNextGun/" ,
    GetNextRegNbr : "/eappreg/getNxtRegNbr/",
    GetCheckDigit : "/eappreg/getChkDigitNbr/",
    sp_web_eappreg_data : "/sp_web_eappreg_data/insEAppRegMaster",
    GetRevTypeInfo : "/eappreg/getRevTypeInfo",
    matchExactAddress : "/eappreg/addresValidation/matchAddressExact",
    matchFuzzyAddress : "/eappreg/addresValidation/matchAddressFuzzy",
    GetTaxCalInfo : "eappreg/getTaxCalInfo/",
    InsEAppRegDetail : "eappreg/insEAppRegDetail/",
    TaxCalcInitBus : "eappreg/taxCalcInitBus",
    TaxCalcPeriodType : "eappreg/taxCalcbasedOnPeriodType",
    InsWeb : "eappreg/InsWebInsert",
    InsWebRnw : "eappreg/InsWebRnw",
    Answers: "eappreg/setAnswers",
    webLogon: "/eappreg/InsWebLogon",
    UpdateWebTaxPayer:"/eappreg/updateWebTaxPayer",
    UpdateWebTaxPayerUsingWebFiling:"/eappreg/updateWebTaxPayerUsingWebFiling",
    GetSystemParm: "/eappreg/getSystemParm/",
 	Previewdata:'/eappreg/previewdata',
    SendReceiptEmail:'/eappreg/sendReceiptEmail',
    SaveAllData: '/eappreg/saveAllData',
    GetStates:'/eappreg/getStates',
    GetNAICS:'/eappreg/getNAICS',
    UpdateTrcSessionForm:'/eappreg/updateTrcSessionForm',
    GetLATAXSSNCnt:'/eappreg/getLATAXSSNCnt/',
    GetLATAXFEINCnt:'/eappreg/getLATAXFEINCnt/',
    GetWebAnswerCnt:'/eappreg/getWebAnswerCnt/',
    MeasureGrid:'/eappreg/getFundClassMeasureGrid/',
	getTRCLevelQues:'/eappreg/getCurrLevelbyQuestionId/',
	getTRCFCLevelQues:'/eappreg/getCurrFCLevelbyQuestionId/',
}